import { Dispatch } from 'redux';
import { getSectionNextByKey } from './feedpage.selectors';
import { fetchMoreArticles } from '../../../services/pilotServiceApiProvider';
import { createArticles } from '../../utils/articles.utils';
import { getImagesCdnHost } from '../../config/config.selectors';
import { SectionNames } from './feedPage.reducer';
import { FeedPageAppState } from '../../initialStateRegistration';
import { getSafeObject, mandatory, nonMandatory } from '../../storeFromRequestParamsValidation';

interface PostsResponse {
  pagination: {
    next: string
  }
  articles: Array<object>
}

export const REQUEST_POSTS = '[feed page] request next posts from service';
export const requestPosts = () => {
  return {
    type: REQUEST_POSTS,
  };
};

export const RECEIVED_POSTS_SUCCESSFULLY = 'RECEIVED_POSTS_SUCCESSFULLY';
export const receivePostsSuccessfully = (response: PostsResponse, key: string, imagesHost: string) => {
  const receivePostsRegistration = (safeResponse: PostsResponse) => ({
    type: RECEIVED_POSTS_SUCCESSFULLY,
    articles: mandatory(safeResponse.articles, [], createArticles(imagesHost)),
    next: nonMandatory(safeResponse.pagination.next),
    sectionKey: key,
  });
  return receivePostsRegistration(getSafeObject(response));
};

export const RECEIVED_POSTS_UNSUCCESSFULLY = 'RECEIVED_POSTS_UNSUCCESSFULLY';
export const receivePostsUnsuccessfully = (error: string) => {
  return {
    type: RECEIVED_POSTS_UNSUCCESSFULLY,
    error,
  };
};

export const fetchNextPosts = (key: SectionNames) => {
    return (dispatch: Dispatch, getState: () => FeedPageAppState) => {
    dispatch(requestPosts());
    const endpoint = getSectionNextByKey(key)(getState());
    if (endpoint) {
        return fetchMoreArticles(endpoint)
            .then((json:PostsResponse) => dispatch(receivePostsSuccessfully(json, key, getImagesCdnHost(getState()))))
            .catch((error:string) => dispatch(receivePostsUnsuccessfully(error)));
    }
    return null;
  };
};
